import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthenticationService } from "../share-modul/services/authentication/authentication.service";
import { UserModel } from "../share-modul/models/user/user.model";
import { RoleNameEnum } from "../share-modul/enums/role-name.enum";

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  //#region Fields
  private user: UserModel | null = null;
  //#endregion

  //#region Constructor
  constructor(private authService: AuthenticationService, private _router: Router) {
    this.authService.loginUser.subscribe(it => {
      this.user = it;
    });
  }
  //#endregion

  //#Private Methods
  canActivate(): boolean {
    const loggedIn = this.user !== null;
    if (loggedIn) {
      this._router.navigateByUrl('venues');
    }
    return !loggedIn;
  }
  //#endregion
}
